import { render, staticRenderFns } from "./nodeTypesLoop.vue?vue&type=template&id=130856c8&"
import script from "./nodeTypesLoop.vue?vue&type=script&lang=js&"
export * from "./nodeTypesLoop.vue?vue&type=script&lang=js&"
import style0 from "./nodeTypesLoop.vue?vue&type=style&index=0&id=130856c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports